export default {
  'imm0008.whereDoYouPlanToLive': '您打算在加拿大哪裡定居？',
  'imm0008.provinceTerritory': '省/地區',
  'imm0008.cityTown': '城市/鎮',
  'imm0008.fullName': '姓名',

  'imm0008.otherNames': '您是否曾用其他姓名（如暱稱、婚前姓名、別名等）？',
  'imm0008.yesUsedOtherName': '如果是，請提供您曾使用的姓名',

  'imm0008.physicalCharacteristics': '身體特徵',
  'imm0008.sex': '性別',
  'imm0008.eyeColour': '眼睛顏色',
  'imm0008.height': '身高（厘米）',

  'imm0008.birthInformation': '出生信息',
  'imm0008.dateOfBirth': '出生日期（年/月/日）',
  'imm0008.cityOfBirth': '出生城市',
  'imm0008.countryOfBirth': '出生國家',

  'imm0008.citizenship': '國籍',
  'imm0008.citizenship1': '第一國籍',
  'imm0008.citizenship2': '第二國籍（如果適用）',

  'imm0008.currentCountryOfResidence': '現在居住地',
  'imm0008.currentResidenceCountry': '國家',
  'imm0008.currentResidenceStatus':
    '居住狀態（例如公民、永久居民、工人、學生、遊客等）',
  'imm0008.currentResidenceVisaIssueDate':
    '簽證簽發日期（年/月/日）（如果適用）',
  'imm0008.currentResidenceVisaExpiryDate':
    '簽證過期日期（年/月/日）（如果適用）',

  'imm0008.lastEntryToCanada':
    '如果您的當前居住國是加拿大，請提供您最近一次入境加拿大的日期和地點',
  'imm0008.lastEntryDate': '日期（年/月/日）',
  'imm0008.lastEntryPlace': '地點',

  'imm0008.previousCountriesResidence': '之前居住的國家',
  'imm0008.hasPreviousCountries':
    '在過去五年中，除了您的國籍國或當前居住國（以上所述）外，您是否在任何其他國家居住超過六個月？',

  'imm0008.previousCountriesTitle': '如果您的回答是“是”，請提供詳細信息。',
  'imm0008.previousCountryTitle': '之前居住的國家 #',
  'imm0008.previousCountryCountry': '國家',
  'imm0008.previousCountryImmigrationStatus':
    '移民狀態（例如公民、永久居民、工人、學生、遊客等）',
  'imm0008.previousCountryImmigrationStartDate': '移民狀態開始日期（年/月/日）',
  'imm0008.previousCountryImmigrationEndDate': '移民狀態結束日期（年/月/日）',

  'imm0008.maritalStatusTitle': '婚姻和關係狀況',
  'imm0008.currentMaritalStatus':
    '當前婚姻狀況（例如已婚、同居、單身、離婚、喪偶等）',
  'imm0008.marriageOrCommonLawDate':
    '（如果已婚或有同居關係）請提供您結婚或開始同居關係的日期。日期（年/月/日）',
  'imm0008.fullNameOfSpouse': '您當前/配偶/同居伴侶的全名（如果適用）',

  'imm0008.previousMarriageOrCommonLawTitle': '之前婚姻或同居關係',
  'imm0008.previouslyMarriedOrCommonLaw': '您之前是否結過婚或同居關係？',
  'imm0008.previousSpouseDetailsTitle':
    '如果之前結過婚或同居關係，請提供您之前配偶/同居伴侶的詳細信息',
  'imm0008.previousSpouseFullName': '您之前配偶/同居伴侶的全名',
  'imm0008.previousSpouseDob': '您之前配偶/同居伴侶的出生日期（年/月/日）',
  'imm0008.typeOfRelationship': '關係類型（已婚或同居）',
  'imm0008.relationshipStartDate': '關係開始日期（年/月/日）',
  'imm0008.relationshipEndDate': '關係結束日期（年/月/日）',

  'imm0008.passportNumber':
    '護照/旅行文件號碼（與您護照或旅行文件上的號碼完全一致）',
  'imm0008.passportCountry':
    '簽發國/國家代碼（與您護照或旅行文件上的國家代碼完全一致）',
  'imm0008.passportIssueDate': '簽發日期（年/月/日）',
  'imm0008.passportExpiryDate': '過期日期（年/月/日）',

  'imm0008.nationalIdDocumentNumber': '身份證號碼/國家身份證明號碼',
  'imm0008.nationalIdCountry': '簽發國/國家代碼',
  'imm0008.nationalIdIssueDate': '簽發日期（年/月/日）',
  'imm0008.nationalIdExpiryDate': '過期日期（年/月/日）',

  'imm0008.educationInfoTitle': '教育信息',
  'imm0008.highestEducation': '最高教育水平',
  'imm0008.educationYears': '教育年限',
  'imm0008.occupationInfoTitle': '職業信息',
  'imm0008.currentOccupation':
    '目前職業（如果您的被撫養人沒有工作，請輸入"未就業"）',
  'imm0008.intendedOccupation':
    '計劃從事的職業（如果您的被撫養人不打算在加拿大工作（例如，如果他們未到工作年齡），請輸入"無"）',

  'imm0008.communicateInEnglishFrench':
    '您能用英語和/或法語交流嗎？（請選擇英語、法語或兩者或兩者都不）',
  'imm0008.takenLanguageTest': '您是否參加過英語或法語水平測試？',

  'imm0008.dependantTableTitle': '其他家庭成員',
  'imm0008.dependantTableFullName': '姓名',
  'imm0008.dependantTableDob': '出生日期（YYYY/MM/DD）',
  'imm0008.dependantTableStatus': '狀態',
  'imm0008.dependantTableStatus.missingInformation': '缺少信息',
  'imm0008.dependantTableStatus.complete': '已完成',

  'imm0008.dependant.title': '被扶養人/家庭成員',
  'imm0008.dependant.description':
    '您必須提供每個家庭成員的以下信息，無論他們是否隨同您前往加拿大。您必須包括您的配偶或同居伴侶（如果適用），以及您所有的被扶養子女，以及您的配偶或同居伴侶的被扶養子女，他們尚未成為加拿大永久居民或公民。',
  'imm0008.personalTitle': '個人信息',
  'imm0008.dependant.willAccompany': '此被扶養人是否隨同主申請人前往加拿大？',
  'imm0008.dependant.relationshipToPrincipalApplicant':
    '與主申請人關係（例如配偶、同居伴侶、子女）',

  // 'imm0008.ifNotChina': '如果不是住在中國，請填寫',
  // 'imm0008.fromDate': '從（年/月/日）',
  // 'imm0008.toDate': '至（年/月/日）',
  // 'imm0008.nationalIdNumber': '身份證號碼',
  // 'imm0008.idFromDate': '開始日期（年/月/日）',
  // 'imm0008.idToDate': '結束日期（年/月/日）',

  'imm0008.steps.app': '申請詳情',
  'imm0008.steps.personal': '個人信息',
  //'imm0008.steps.contact': '聯繫信息',
  'imm0008.steps.passport': '護照',
  'imm0008.steps.id': '身份證',
  'imm0008.steps.career': '教育/職業詳情',
  'imm0008.steps.language': '語言能力',
  'imm0008.steps.dependant': '家庭成員',
};
